import { CourseService } from 'data/services';
import { CourseServiceInterface } from 'domain/services';
import { makeGetAllCoursesUser } from 'main/factories/usecases/courses/remote-get-all-courses-user-factory';

export const makeCourseService = (): CourseServiceInterface => {
  return new CourseService(makeGetAllCoursesUser());
};
